import React, { useEffect, useState } from 'react';
import api from '../../utils/axios';
import { useNavigate, useParams } from 'react-router-dom';

const EditVehicle = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    plateNumber: '',
    office: '',
    type: '',
    status: '',
    remarks: ''
  });

  const [error, setError] = useState('');

  useEffect(() => {
    const fetchVehicle = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await api.get(`/api/vehicles/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setForm(res.data);
      } catch (err) {
        console.error('Failed to fetch vehicle:', err);
        setError('Failed to load vehicle');
      }
    };
    fetchVehicle();
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const token = localStorage.getItem('token');
      await api.put(`/api/vehicles/${id}`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      navigate('/vehicles');
    } catch (err) {
      console.error(err);
      setError('Failed to update vehicle.');
    }
  };

  return (
    <div className="container mt-4">
      <h2>Edit Vehicle</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Name</label>
          <input type="text" name="name" value={form.name} onChange={handleChange} className="form-control" required />
        </div>
        <div className="mb-3">
          <label>Plate Number</label>
          <input type="text" name="plateNumber" value={form.plateNumber} onChange={handleChange} className="form-control" required />
        </div>
        <div className="mb-3">
          <label>Office</label>
          <select name="office" value={form.office} onChange={handleChange} className="form-select" required>
            <option value="">-- Select Office --</option>
            <option value="HQ">HQ</option>
            <option value="SITE">Site</option>
          </select>
        </div>
        <div className="mb-3">
          <label>Type</label>
          <input type="text" name="type" value={form.type} onChange={handleChange} className="form-control" />
        </div>
        <div className="mb-3">
          <label>Status</label>
          <select name="status" value={form.status} onChange={handleChange} className="form-select">
            <option value="">-- Select Status --</option>
            <option value="active">Active</option>
            <option value="maintenance">Maintenance</option>
            <option value="retired">Retired</option>
          </select>
        </div>
        <div className="mb-3">
          <label>Remarks</label>
          <textarea name="remarks" value={form.remarks} onChange={handleChange} className="form-control" />
        </div>
        <button type="submit" className="btn btn-primary">Update Vehicle</button>
      </form>
    </div>
  );
};

export default EditVehicle;
